import { Mail, MapPin, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[var(--ew-accent)] text-white pt-16 pb-10"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white text-[var(--ew-accent)] font-heading font-semibold">
                E
              </span>
              <span className="font-heading text-xl font-semibold tracking-tight">
                Everwell Community Nursing Pty Ltd
              </span>
            </div>
            <p className="mt-5 text-white/80 leading-relaxed max-w-md">
              Helping participants stay well at home.
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="font-heading text-sm uppercase tracking-[0.18em] text-white/60">
              Contact
            </p>
            <ul className="mt-4 space-y-3 text-white/90">
              <li>
                <a
                  href="tel:0450270547"
                  className="inline-flex items-center gap-3 hover:text-white transition-colors"
                >
                  <Phone className="h-4 w-4" strokeWidth={1.75} />
                  0450 270 547
                </a>
              </li>
              <li>
                <a
                  href="mailto:everwellcommunitynursing@gmail.com"
                  className="inline-flex items-center gap-3 hover:text-white transition-colors break-all"
                >
                  <Mail className="h-4 w-4 shrink-0" strokeWidth={1.75} />
                  everwellcommunitynursing@gmail.com
                </a>
              </li>
              <li>
                <span className="inline-flex items-center gap-3">
                  <MapPin className="h-4 w-4" strokeWidth={1.75} />
                  Canberra, ACT
                </span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-heading text-sm uppercase tracking-[0.18em] text-white/60">
              Explore
            </p>
            <ul className="mt-4 space-y-2.5 text-white/90">
              {[
                { href: "#about", label: "About" },
                { href: "#services", label: "Services" },
                { href: "#referrals", label: "Referrals" },
                { href: "#contact", label: "Contact" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-sm text-white/70">
            © {new Date().getFullYear()} Everwell Community Nursing Pty Ltd.
            All rights reserved.
          </p>
          <p className="text-xs text-white/60">
            Proudly Canberra-based • Serving Canberra & nearby NSW
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
